class WebSocketService {
    constructor() {
    this.socket = null;
  }

  connect(onMessage) {
    const token = JSON.parse(localStorage.getItem("accessToken"));
    const base_url = process.env.REACT_APP_WS_BASE_URL || 'wss://srv542037.hstgr.cloud:8282';

    this.socket = new WebSocket(`${base_url}/ws?token=${token}`);

    this.socket.onopen = () => {
      console.log("CONNECTED");
    };

    this.socket.onmessage = (event) => {
      const data = event.data;
      onMessage(data);
    };

    this.socket.onerror = (err) => {
      console.error("WEBSOCKET ERROR:", err);
    };

    this.socket.onclose = () => {
      console.log("DISCONNECTED");
    };
  }

  sendMessage(msg) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(msg));
    }
  }

  disconnect() {
    if (this.socket) this.socket.close();
  }
}

export default WebSocketService;